import React from "react";
import { type LineSearchDropdownProps } from "@bloomberg/media-ui-dropdown";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import styles from "./styles.module.css";
import TickerSearch from "~components/Portfolio/TickerSearch";
import { usePageData } from "~context/PageContext";
import { useTranslateMessage } from "~utils/i18n";

type DropdownOptions = LineSearchDropdownProps["options"];

export function SearchControls({
  disabled,
  onAddTicker,
}: {
  disabled: boolean;
  onAddTicker: (
    id: DropdownOptions[0] | null,
    downshiftHandle: { setState: (value: unknown) => void }
  ) => void;
}) {
  const { countryCode, searchClientURL } = usePageData();
  const translate = useTranslateMessage();

  const translations = {
    addComparison: translate({
      id: "addAComparison",
      defaultMessage: "Add a comparison",
    }),
    deleteComparison: translate({
      id: "deleteOneAddComparison",
      defaultMessage: "Delete one to add a new comparison",
    }),
  };

  return (
    <div className={styles.searchDropdownContainer}>
      <TickerSearch
        disabled={disabled}
        countryCode={countryCode}
        searchURL={searchClientURL}
        onChange={onAddTicker}
        className={typographyStyles.coreParagraphSm}
        placeholder={
          disabled ? translations.deleteComparison : translations.addComparison
        }
      />
    </div>
  );
}
